@if (data.title) {
  <h1 mat-dialog-title>{{ data.title }}</h1>
}

<mat-dialog-content>
  <p [innerHTML]="data.message | safeHtml" class="mb-4"></p>

  <div class="space-y-2">
    <div class="font-medium text-sm">{{ data.input.label }}</div>

    <mat-form-field class="w-full form-field-dense">
      @if (data.input.mode === 'textarea') {
        <textarea
          cdkFocusInitial
          matInput
          [formControl]="control"
          [placeholder]="data.input.placeholder ?? ''"
          autocomplete="off"
          spellcheck="false"
          [rows]="rows"
          [cdkTextareaAutosize]="data.input.autoResize"
          [cdkAutosizeMinRows]="minRows"
          [cdkAutosizeMaxRows]="maxRows"
        ></textarea>
      } @else {
        <input
          cdkFocusInitial
          matInput
          type="text"
          [formControl]="control"
          [placeholder]="data.input.placeholder ?? ''"
          autocomplete="off"
          spellcheck="false"
          (keydown.enter)="!submitted() && control.valid && handleConfirm()"
        />
      }

      @if (errorMessage) {
        <mat-error>{{ errorMessage }}</mat-error>
      }
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="undefined" [disabled]="submitted()">
    {{ data.cancelText }}
  </button>

  <button
    mat-button
    (click)="handleConfirm()"
    [disabled]="submitted() || control.invalid"
    cdkFocusInitial
  >
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">{{
      data.confirmText
    }}</span>
  </button>
</mat-dialog-actions>
